import Form from "react-bootstrap/Form";
import { WidgetProps } from "@rjsf/core";
import { isNil, isNumber } from "lodash";
import { useIMask } from "react-imask";
import WidgetLabel from "components/JsonForm/theme/widgets/WidgetLabel";

export function CurrencyWidget(props: WidgetProps) {
    const {
        id,
        label,
        uiSchema,
        placeholder,
        required,
        readonly,
        disabled,
        value,
        onBlur,
        onFocus,
        autofocus,
        autoComplete,
        options,
        schema,
        rawErrors = [],
        onChange,
        style,
    } = props;

    let { min, max } = props;
    const _onBlur = ({ target: { value } }: React.FocusEvent<HTMLInputElement>) => onBlur(id, value);
    const _onFocus = ({ target: { value } }: React.FocusEvent<HTMLInputElement>) => onFocus(id, value);
    const isInvalid = rawErrors && rawErrors.length > 0;
    const { defaultAriaDescribedBy } = options;
    const step = isNumber(schema.multipleOf) ? schema.multipleOf : undefined;

    if (isNil(min)) {
        min = schema.exclusiveMinimum ? schema.exclusiveMinimum + 1 : schema.minimum;
    }

    if (isNil(max)) {
        max = schema.exclusiveMaximum ? schema.exclusiveMaximum - 1 : schema.maximum;
    }

    const { ref } = useIMask<HTMLInputElement>(
        {
            lazy: true,
            mask: "$ num",
            blocks: {
                num: {
                    mask: Number,
                    thousandsSeparator: ",",
                    radix: ".",
                    normalizeZeros: true,
                    mapToRadix: ["."],
                    max: 9999999999999.99,
                    min: -9999999999999.99
                },
            },
        },
        {
            defaultUnmaskedValue: value?.toString(),
            onAccept: (_, masklRef) => onChange(masklRef.unmaskedValue),
        }
    );

    return (
        <>
            {label && (
                <WidgetLabel
                    id={id}
                    label={label}
                    uiSchema={uiSchema}
                    schema={schema}
                    required={required}
                    rawErrors={rawErrors}
                />
            )}
            <Form.Control
                id={id}
                ref={ref}
                placeholder={`$ ${placeholder}`}
                autoFocus={autofocus}
                autoComplete={autoComplete}
                required={required}
                disabled={disabled}
                readOnly={readonly}
                isInvalid={isInvalid}
                aria-describedby={isInvalid ? `${id}-error` : `${defaultAriaDescribedBy}`}
                aria-invalid={isInvalid}
                list={schema.examples ? `examples_${id}` : undefined}
                min={min}
                max={max}
                onBlur={_onBlur}
                onFocus={_onFocus}
                step={step}
                style={style}
            />
        </>
    );
}
